import { Api } from "../Api";

export const carregaParcelas = async (e) => {
  const { valor, tipo, usuario_id, provider_id, parcelas, bandeira } = e;
  const { data } = await Api.get(
    `parcelamentos/listv2/generica/${valor}/${tipo}/${parcelas}/${usuario_id}/${provider_id}/${bandeira}`
  );
  return data;
};

export const descontoVencimetoBoleto = async (usuario_id) => {
  try {
    const { data } = await Api.get(`boletos/parametros/${usuario_id}`);
    return data;
  } catch (error) {
    console.error(error);
    // return toast.error(
    //   "Algo deu errado ao carregar as datas de vencimento, tente novamente."
    // );
  }
};

export const carregaParcelasCaema = async (e) => {
  const { documento } = e;
  try {
    const { data } = await Api.get(`/genericnegotiation/cotacaoCotapay/${documento}`);
    return data;
  } catch (error) {
    console.error(error);
    // return toast.error(
    //   "Algo deu errado ao carregar as datas de vencimento, tente novamente."
    // );
  }
};

export const carregaParcelasV3 = async (e) => {
  const { valor, tipo, usuario_id, provider_id, parcelas, bandeira } = e;
  try {
    const { data } = await Api.get(
      `parcelamentos/listv3/${valor}/${tipo}/${parcelas}/${provider_id}/${usuario_id}/${bandeira}`
    );
    return data;
  } catch (error) {
    console.error(error);
    // return toast.error(
    //   "Algo deu errado ao carregar as datas de vencimento, tente novamente."
    // );
  }
};

export const carregaParcelasV4 = async (e) => {
  const { valor, tipo, usuario_id, provider_id, parcelas, bandeira } = e;
  try {
    const { data } = await Api.get(
      `parcelamentos/listv4/${valor}/${tipo}/${parcelas}/${provider_id}/${usuario_id}/${bandeira}`
    );
    return data;
  } catch (error) {
    console.error(error);
    // return toast.error(
    //   "Algo deu errado ao carregar as datas de vencimento, tente novamente."
    // );
  }
};
